import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import Landing from './pages/Landing';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import WhatsApp from './pages/WhatsApp';
import AIConfig from './pages/AIConfig';
import Conversations from './pages/Conversations';
import Appointments from './pages/Appointments';
import Products from './pages/Products';
import Campaigns from './pages/Campaigns';
import Media from './pages/Media';
import Tokens from './pages/Tokens';
import Analytics from './pages/Analytics';
import Profile from './pages/Profile';

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Dashboard */}
            <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="whatsapp" element={<WhatsApp />} />
              <Route path="ai-config" element={<AIConfig />} />
              <Route path="conversations" element={<Conversations />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="products" element={<Products />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="media" element={<Media />} />
              <Route path="tokens" element={<Tokens />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
